import React from "react";
import { LinkedDestination } from "../../../../models/Entities";
import MergeTable from "../../../shared/MergeTable";
import EmptyStateWrapper from "../../../shared/EmptyStateWrapper";
import TableSkeletonLoader from "../../shared/TableSkeletonLoader";
import LinkedDestinationTableRows from "./LinkedDestinationTableRows";

type LinkedDestinationTableProps = {
  isLoading: boolean;
  linked_destinations?: LinkedDestination[];
  setLinkedDestinationToDelete: (destination: LinkedDestination) => void;
};

function LinkedDestinationTable(props: LinkedDestinationTableProps) {
  const { isLoading, linked_destinations, setLinkedDestinationToDelete } = props;

  const header = (
    <>
      <th scope="col">Destination</th>
      <th scope="col">Status</th>
      <th scope="col">Linked Destination ID</th>
      <th />
    </>
  );

  const content = (
    <>
      {!isLoading && linked_destinations ? (
        linked_destinations.length ? (
          <LinkedDestinationTableRows
            linked_destinations={linked_destinations}
            setLinkedDestinationToDelete={setLinkedDestinationToDelete}
          />
        ) : (
          <tr>
            <td colSpan={3}>
              <EmptyStateWrapper
                isTable
                title="You have no Destinations. Click the button in the top right to add a Destination."
              />
            </td>
          </tr>
        )
      ) : (
        <TableSkeletonLoader cols={3} rows={5} size="large" />
      )}
    </>
  );

  return (
    <MergeTable hover={false} header={header} content={content} hasMorePaddingOnFirstElement />
  );
}
export default LinkedDestinationTable;
